// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__290QB","errors":"Errors_errors__1e5fT"};